import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "error"]
  static values = { message: String }

  connect() {
    this.validate()
  }

  validate() {
    const value = this.inputTarget.value.trim()
    // Regex identique à celui du modèle Ruby
    const emailRegex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/
    if (value === "" || emailRegex.test(value)) {
      this.errorTarget.textContent = ""
      this.inputTarget.setCustomValidity("")
    } else {
      this.errorTarget.textContent = this.messageValue
      this.inputTarget.setCustomValidity(this.messageValue)
    }
  }

  onInput() {
    this.validate()
  }

  onBlur() {
    this.validate()
  }
} 